import type { DocumentOwnerType } from '../../api/areas/accounts';
import { EntityRef } from '../../components/EntityRef';
import { paths, useEnumLabel } from './shared';

const OWNER_PATHS: Record<DocumentOwnerType, (id: string) => string> = {
  SUBJECT: paths.subject,
  DOSSIER: paths.dossier,
  CUSTOMER: paths.customer,
  CASE: paths.abuseCase,
};

/** A document's owner by name (registrant, dossier's domain, account or case number), linking to its page. */
export function OwnerLink({ type, id, name }: { type: DocumentOwnerType; id: string; name: string | null | undefined }) {
  const enumLabel = useEnumLabel('accounts');
  return <EntityRef label={name ?? undefined} to={OWNER_PATHS[type](id)} id={id} sub={enumLabel('ownerType', type)} />;
}
